import { render, staticRenderFns } from "./save-publish-and-close-modal-buttons.vue?vue&type=template&id=58c27f98&scoped=true"
import script from "./save-publish-and-close-modal-buttons.vue?vue&type=script&lang=js"
export * from "./save-publish-and-close-modal-buttons.vue?vue&type=script&lang=js"
import style0 from "./save-publish-and-close-modal-buttons.vue?vue&type=style&index=0&id=58c27f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c27f98",
  null
  
)

export default component.exports